import {ProductionCostBusScheduleKpi} from '@/Pages/ProductionCost/store/types';
import {getKmsOrMiles} from '@/Pages/Common/LabelUtils';
import {ReadOnlyKpiInputConfig} from '../../../../hooks/useReadOnlyKpiInputConfigBuilder';
import {formatSmartRounded} from '@/services/formatters';

export const LineScheduleVehicleKpisConfig: Partial<{
  [K in keyof ProductionCostBusScheduleKpi]: ReadOnlyKpiInputConfig;
}> = {
  totalDistance: {
    label: 'Total distance:',
    formatValue: (kpi, units) =>
      `${
        kpi.value === null ? 'N/A' : formatSmartRounded(kpi.value)
      } ${getKmsOrMiles(units)}`,
    id: 'production-cost-bus-schedule-total-distance',
    order: 1
  },
  avgWeeklyOpDays: {
    label: 'Avg. operating days:',
    formatValue: kpi =>
      `${kpi.value === null ? 'N/A' : formatSmartRounded(kpi.value)} days/week`,
    id: 'production-cost-bus-schedule-avg-operating-days',
    order: 2
  },
  totalScheduleHours: {
    label: 'Total schedule hours:',
    formatValue: kpi =>
      `${kpi.value === null ? 'N/A' : formatSmartRounded(kpi.value)} hours`,
    id: 'production-cost-bus-schedule-total-schedule-hours',
    order: 3
  },
  avgWeeklyDistance: {
    label: 'Average Distance:',
    formatValue: (kpi, units) =>
      `${
        kpi.value === null ? 'N/A' : formatSmartRounded(kpi.value)
      } ${getKmsOrMiles(units)}/week`,
    id: 'production-cost-bus-schedule-avg-weekly-distance',
    order: 4
  }
};
